import styles from "./SelectGame.module.less";
import DownTime from "../components/DownTime";
import NoticeText from "../components/NoticeText";
import DSBridge from "dsbridge";
import { useState, useEffect, useRef } from "react";
import { getGameAudio, getMaterialsByGame } from "@/api/mine";
import { showDeviceModal } from "views/mine/device-manage/components/device-modal";
import { Toast } from "react-vant";
import { useSearchParams } from "react-router-dom";

const SelectGame = () => {
  const [searchParams] = useSearchParams();
  const [title, setTitle] = useState("");
  const [options, setOptions] = useState([]);
  const isStartRef = useRef(false);
  const downTimeRef = useRef(null);
  const explanationRef = useRef(null);

  const handleClose = () => {
    showDeviceModal({
      message: "确定退出课堂练习？中途退出无法获得积分哦~退出后将继续学习课程。",
      onConfirm: () => {
        DSBridge.call("stopSound", "bgm_sound");
        DSBridge.call("exitWebView");
      },
      isShowCancel: true,
      isShowConfirm: true,
      cancelText: "取消",
      confirmText: "退出",
    });
  };

  const handleGetAudio = async (text) => {
    try {
      // const res = await getGameAudio({
      //   character_id: "lily_white",
      //   token: "IMdW6ZWukrH6qrUteWDa6Mzm-SR-zPxW3z1Iq-2xg08.",
      //   text: text,
      // });
      const res = await getGameAudio({
        character_id: searchParams.get("character_id"),
        token: searchParams.get("token"),
        text: text,
      });
      if (res.code === 200 && res.data?.url) {
        return res.data.url;
      }
      throw new Error("Failed to get audio URL");
    } catch (error) {
      throw error;
    }
  };

  // 提取播放音频和退出的公共逻辑
  const playAudioAndExit = async (explanationText, score = 0) => {
    try {
      const audioUrl = await handleGetAudio(explanationText);
      DSBridge.call(
        "playOnlineSound",
        `${process.env.REACT_APP_API_CDN}/${audioUrl}`,
        () => {
          if (score > 0) {
            DSBridge.call("addScore", score.toString());
          }
          DSBridge.call("exitWebView");
        }
      );
    } catch {
      if (score > 0) {
        DSBridge.call("addScore", score.toString());
      }
      DSBridge.call("exitWebView");
    }
  };

  // 显示所有答案
  const showAllAnswers = () => {
    setOptions((prev) => prev.map((item) => ({ ...item, isShow: true })));
  };

  const handleTimeEnd = () => {
    isStartRef.current = false;
    DSBridge.call("stopSound", "bgm_sound");
    DSBridge.call("playSVGA", "missed", () => {
      showAllAnswers();
      playAudioAndExit(explanationRef.current?.noAnswer);
    });
  };

  const handleSelect = (type) => {
    if (!isStartRef.current) return;

    // 更新选中状态
    const index = type === "left" ? 0 : 1;
    setOptions((prev) =>
      prev.map((item, i) => (i === index ? { ...item, isShow: true } : item))
    );

    // 停止游戏
    downTimeRef.current.stopCountdown();
    isStartRef.current = false;
    DSBridge.call("stopSound", "bgm_sound");

    const isCorrect = options[index].isCorrect;
    const svgaName = isCorrect ? "outstanding" : "nice_try";
    const explanationText = isCorrect
      ? explanationRef.current?.correct
      : explanationRef.current?.incorrect;
    const score = isCorrect ? 10 : 5;

    DSBridge.call("playSVGA", svgaName, () => {
      if (!isCorrect) {
        showAllAnswers();
      }
      playAudioAndExit(explanationText, score);
    });
  };

  const initGame = async () => {
    try {
      // const res = {
      //   code: 200,
      //   status: true,
      //   data: {
      //     type: 14,
      //     question: "Time to practice!",
      //     question_zh: "",
      //     answer: "",
      //     image:
      //       "https://cdn03.myaitalk.vip/utalkrc/materials/slides/game_time_slides/game_3.jpg",
      //     practice_config: {
      //       type: "image-choice",
      //       guide: "Choose the right one!",
      //       duration: 12,
      //       explanation: {
      //         correct:
      //           "Well done! That's afternoon. It means the time of day after lunch and before evening.",
      //         incorrect:
      //           "Not quite. The correct answer is afternoon. It's the time between 12 p.m. and evening.",
      //         noAnswer:
      //           "The word we were looking for is afternoon. It comes after noon and before the evening.",
      //       },
      //       title: "Choose the right one. A or B.",
      //       config: {
      //         options: [
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_e4398445-a8e6-48eb-9f2c-66d57ab2eca2.png",
      //             isCorrect: false,
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_1864b2f3-5649-4d62-9154-4cbbaaf43d9b.png",
      //             isCorrect: true,
      //           },
      //         ],
      //       },
      //     },
      //   },
      //   message: "success",
      // };
      const res = await getMaterialsByGame({
        material_id: searchParams.get("material_id"),
        token: searchParams.get("token"),
        unit_id: searchParams.get("unit_id"),
      });
      if (res.code === 200) {
        const config = res.data?.practice_config;
        if (config?.type !== "image-choice") {
          Toast.info("游戏类型错误，请点击左上角退出");
          return;
        }
        explanationRef.current = config?.explanation;
        setTitle(config?.title || "");
        setOptions(config?.config?.options || []);
        try {
          const audioUrl = await handleGetAudio(config?.guide);
          DSBridge.call(
            "playOnlineSound",
            `${process.env.REACT_APP_API_CDN}/${audioUrl}`,
            () => {
              downTimeRef.current?.startCountdown(config?.duration);
              isStartRef.current = true;
            }
          );
        } catch (er){
          console.log(er)
          downTimeRef.current?.startCountdown(config?.duration);
          isStartRef.current = true;
        }
      } else {
        Toast.info("请求游戏数据失败，请点击左上角退出");
      }
    } catch {
      Toast.info("验证游戏数据失败，请点击左上角退出");
    }
  };

  useEffect(() => {
    DSBridge.call("playSound", "bgm_sound");
    initGame();
    return () => {
      DSBridge.call("stopSound", "bgm_sound");
    };
  }, []);

  // 渲染选项组件
  const renderOption = (option, index, position) => (
    <div
      key={index}
      className={styles[`${position}-select`]}
      onClick={() => handleSelect(position)}
    >
      <div className={styles[`${position}-select-cover`]}>
        <img className={styles["cover-img"]} src={option.image} />
      </div>
      {option.isShow && (
        <div
          className={
            styles[`${position}-select-${option.isCorrect ? "true" : "false"}`]
          }
        />
      )}
    </div>
  );

  return (
    <div className={styles["select-game-container"]}>
      <div className={styles["back-top"]} />
      <div className={styles["back-bottom"]} />
      <div className={styles["title"]}>
        <div className={styles["title-text"]}>{title}</div>
      </div>
      {options.length === 2 && (
        <div className={styles["center-box"]}>
          {renderOption(options[0], 0, "left")}
          {renderOption(options[1], 1, "right")}
        </div>
      )}
      <NoticeText text="Choose  听一听，选择正确的图片" />
      <DownTime ref={downTimeRef} onTimeEnd={handleTimeEnd} />
      <div className={styles["close-icon"]} onClick={handleClose}>
        <img
          className={styles["close-icon-img"]}
          src={require("@/images/new-game/common/close.png")}
        />
      </div>
    </div>
  );
};

export default SelectGame;
